module.exports = __webpack_public_path__ + "static/media/ImpactStoryLogoNusCtic.6d2d8b08.png";